<template>
  <el-dialog
    :title="title"
    :visible.sync="addInsecurityEventVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="insecurityEventRef" label-width="150px" :model="insecurityEventForm">
      <el-form-item
        label="不安全事件名称"
        prop="name"
        :rules="[
          {
            required: true,
            message: '请输入不安全事件名称',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="insecurityEventForm.name"
          maxlength="50"
          placeholder="请输入不安全事件名称"
        />
      </el-form-item>
      <el-form-item
        label="考核"
        prop="assessment"
        :rules="[
          {
            required: true,
            message: '请输入考核',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="insecurityEventForm.assessment"
          maxlength="50"
          placeholder="请输入考核"
        />
      </el-form-item>
      <el-form-item label="附件" prop="attachment" ref="attachment">
        <form-upload
          v-model="insecurityEventForm.attachment"
          :limit="1"
          :accept="['jpg', 'png', 'doc', 'docx', 'pdf', 'xlsx', 'xls']"
          @change="fileIdChange('attachment')"
          class="w-440px"
        ></form-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import utils from '@/components/safety/enumField/utils'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import { ContractorApi } from '@wiz-api/contractor-management'
import dayjs from 'dayjs'

const safetyProductionFilesApi = new ContractorApi()
export default {
  components: {
    FormUpload,
  },
  model: {
    prop: 'addInsecurityEventVisible',
    event: 'addInsecurityEventChange',
  },
  props: {
    addInsecurityEventVisible: {
      type: Boolean,
      default: false,
    },
    contractorId: {
      type: String,
      default: '',
    },
    saveInsecurityEventRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '上传不安全事件',
      loading: false,
      insecurityEventForm: {},
      taskFrequencyType: [],
      workPermitCategoryList: [],
    }
  },
  watch: {
    saveInsecurityEventRow(val) {
      if (val.id) {
        this.insecurityEventForm = val
        this.title = '编辑不安全事件'
      }
    },
  },
  methods: {
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.insecurityEventForm = {}
      this.$refs.insecurityEventRef.resetFields()
      this.$emit('addInsecurityEventChange', false)
    },
    save() {
      this.$refs.insecurityEventRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          if (!this.saveInsecurityEventRow.id) {
            const [err, res] = await safetyProductionFilesApi.createSafetyProductionFile(
              this.contractorId,
              {
                body: this.insecurityEventForm,
              }
            )
            if (!err) {
              this.$message.success('保存成功')
              this.cancel()
            }
          } else {
            const [err, res] = await safetyProductionFilesApi.updateafetyProductionFile(
              this.contractorId,
              this.saveInsecurityEventRow.id,
              {
                body: this.insecurityEventForm,
              }
            )
            if (!err) {
              this.$message.success('编辑成功')
              this.cancel()
            }
          }

          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
</style>
